import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { FieldType, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { RadioButton } from 'primeng/radiobutton';

interface RadioProps extends CoreFormlyFieldProps {
  options?: Array<{ label: string; value: any }>;
}

@Component({
  selector: 'formly-field-primeng-radio',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    RadioButton
  ],
  template: `
    <div class="flex flex-wrap gap-3">
      <div *ngFor="let option of props.options" class="flex align-items-center">
        <p-radioButton
          [id]="id + '_' + option.value"
          [name]="id"
          [value]="option.value"
          [formControl]="radioControl"
          [formlyAttributes]="field"
        ></p-radioButton>
        <label 
          [for]="id + '_' + option.value" 
          class="ml-2 cursor-pointer"
        >{{ option.label }}</label>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyFieldRadio extends FieldType<FormlyFieldConfig<RadioProps>> {
  get radioControl() {
    return this.formControl as FormControl;
  }
}